import React from 'react';
import './App.css';
import { BrowserRouter, Redirect, Route,Link,NavLink, Routes, Navigate,
  Outlet} from 'react-router-dom';
import { useNavigate } from 'react-router';
import {  useState, useEffect } from 'react';
import Home from "./Home";
import CompanyForm from "./forms/admin/CompanyForm";
import CompanyTable from "./forms/admin/CompanyTable";
import CompanyEdit from "./forms/admin/CompanyForm";
import UnitForm from "./forms/admin/UnitForm";
import UnitTable from "./forms/admin/UnitTable";
import UnitEdit from "./forms/admin/UnitForm";
import Tax from "./forms/admin/Tax";
import TaxEdit from "./forms/admin/TaxEdit";
import Gang from "./forms/admin/Gang";
import GangEdit from "./forms/admin/GangEdit";
import Vendor from "./forms/purchase/Vendor";
import VendorTable from "./forms/purchase/VendorTable";
import VendorEdit from "./forms/purchase/VendorEdit";
import Product from "./forms/admin/Product";
import ProductEdit from "./forms/admin/ProductEdit";
import Permission from "./forms/admin/Permission";
import PermissionEdit from "./forms/admin/PermissionEdit";
import IpAddress from "./forms/admin/IpAddress";
import IpAddressEdit from "./forms/admin/IpAddressEdit";
import User from "./forms/admin/User";
import UserTable from "./forms/admin/UserTable";
import UserEdit from "./forms/admin/UserEdit";
import Login from "./Login";
import NumberSetting from "./forms/admin/NumberSetting";
import NumberSettingEdit from "./forms/admin/NumberSettingEdit";
import ApprovalSetting from "./forms/admin/ApprovalSetting";
import ApprovalSettingTable from "./forms/admin/ApprovalSettingTable";
import ApprovalSettingEdit from "./forms/admin/ApprovalSettingEdit";
import CustomerMain from "./forms/marketing/CustomerMain";
import CustomerMainEdit from "./forms/marketing/CustomerMainEdit";
import CustomerSite from "./forms/marketing/CustomerSite";
import CustomerSiteTable from "./forms/marketing/CustomerSiteTable";
import CustomerSiteEdit from "./forms/marketing/CustomerSiteEdit";
import SalesOrder from "./forms/marketing/SalesOrder";
import SalesOrderEdit from "./forms/marketing/SalesOrderEdit";
//import SOApproval from "./SOApproval";
import DesignMix from "./forms/qualitycontrol/DesignMix";
import DesignMixEdit from "./forms/qualitycontrol/DesignMixEdit";
import MoistureCorrection from "./forms/qualitycontrol/MoistureCorrection"
import MoistureCorrectionTable from "./forms/qualitycontrol/MoistureCorrectionTable";
import MoistureCorrectionEdit from "./forms/qualitycontrol/MoistureCorrectionEdit";
import CubeTestReport from "./forms/qualitycontrol/CubeTestReport";
import CubeTestReportEdit from "./forms/qualitycontrol/CubeTestReportEdit";
import CubeTestReportTable from "./forms/qualitycontrol/CubeTestReportTable";
import WorkSchedule from "./forms/Planning/WorkSchedule";
// import So2Schedule from "./So2Schedule";
import WorkScheduleEdit from "./forms/Planning/WorkScheduleEdit";
import JobCompletion from "./forms/Planning/JobCompletion";
import JobCompletionReport from "./forms/Planning/JobCompletionReport";
 import PumpClearance from "./forms/dispatch/PumpClearance";
// import PumpSchedule from "./PumpSchedule";
import PumpClearanceEdit from "./forms/dispatch/PumpClearanceEdit";
import DeliveryChallan from "./forms/dispatch/DeliveryChallan";
import DeliveryChallanEdit from "./forms/dispatch/DeliveryChallanEdit";
import DeliveryChallanTable from "./forms/dispatch/DeliveryChallanTable";
import CheckIn from "./forms/gate/CheckIn";
import CheckInEdit from "./forms/gate/CheckInEdit";
import CheckOut from "./forms/gate/CheckOut";
import CheckOutTable from "./forms/gate/CheckOutTable";
import CheckOutEdit from "./forms/gate/CheckOutEdit";
import VehicleGatePass from "./forms/gate/VehicleGatePass";
import VehicleGatePassTable from "./forms/gate/VehicleGatePassTable";
import VehicleGatePassEdit from "./forms/gate/VehicleGatePassEdit";
import Equipment from "./forms/Transport/Equipment";
import EquipmentEdit from "./forms/Transport/EquipmentEdit";
import DirectInvoice from "./forms/accounts/DirectInvoice";
import DirectInvoiceEdit from "./forms/accounts/DirectInvoiceEdit";
import SalesInvoiceEdit from "./forms/accounts/SalesInvoiceEdit";
import  SalesInvoiceTable from "./forms/accounts/SalesInvoiceTable";
import ReceiptVoucher from "./forms/accounts/ReceiptVoucher";
import ReceiptVoucherEdit from "./forms/accounts/ReceiptVoucherEdit";
import ReceiptVoucherTable from "./forms/accounts/ReceiptVoucherTable";
import PaymentVoucher from "./forms/accounts/PaymentVoucher";
import PaymentVoucherEdit from "./forms/accounts/PaymentVoucherEdit";
import PaymentVoucherTable from "./forms/accounts/PaymentVoucherTable";
import ContraVoucher from "./forms/accounts/ContraVoucher";
import ContraVoucherEdit from "./forms/accounts/ContraVoucherEdit";
import ContraVoucherTable from "./forms/accounts/ContraVoucherTable";
import GeneralJournal from "./forms/accounts/GeneralJournal";
import GeneralJournalEdit from "./forms/accounts/GeneralJournalEdit";
import GeneralJournalTable from "./forms/accounts/GeneralJournalTable";
import CreditNote from "./forms/accounts/CreditNote";
import CreditNoteEdit from "./forms/accounts/CreditNoteEdit";
import DebitNote from "./forms/accounts/DebitNote";
import DebitNoteEdit from "./forms/accounts/DebitNoteEdit";
import PurchaseOrder from "./forms/purchase/PurchaseOrder";
import PurchaseOrderEdit from "./forms/purchase/PurchaseOrderEdit";
import PurchaseOrderTable from "./forms/purchase/PurchaseOrderTable";
import PurchaseInvoice from "./forms/purchase/PurchaseInvoice";
import PurchaseCreditNote from "./forms/purchase/PurchaseCreditNote";
import PurchaseCreditNoteEdit from "./forms/purchase/PurchaseCreditNoteEdit";
import PurchaseCreditNoteTable from "./forms/purchase/PurchaseCreditNoteTable";
import PurchaseDebitNote from "./forms/purchase/PurchaseDebitNote";
import PurchaseDebitNoteEdit from "./forms/purchase/PurchaseDebitNoteEdit";
import PurchaseDebitNoteTable from "./forms/purchase/PurchaseDebitNoteTable";
import PurchaseInvoiceEdit from "./forms/purchase/PurchaseInvoiceEdit";
import Quotation from "./forms/marketing/Quotation";
import QuotationEdit from "./forms/marketing/QuotationEdit";
import QuotationTable from "./forms/marketing/QuotationTable";
import ConsumptionNote from "./forms/store/ConsumptionNote";
import ConsumptionNoteEdit from "./forms/store/ConsumptionNoteEdit";
import ConsumptionNoteTable from "./forms/store/ConsumptionNoteTable";
import DieselConsumption from "./forms/store/DieselConsumption";
import DieselConsumptionEdit from "./forms/store/DieselConsumptionEdit";
import DieselConsumptionView from "./forms/store/DieselConsumptionView";
import DieselConsumptionTable from "./forms/store/DieselConsumptionTable";
import CustomerDataReport from "./forms/reports/CustomerDataReport";
import ProductionReport from "./forms/reports/ProductionReport";
import EquipmentReport from "./forms/reports/EquipmentReport";
import GstReport from "./forms/reports/GstReport";
import ReceiptReport from "./forms/reports/ReceiptReport";
import AccountReceivableReport from "./forms/reports/AccountReceivableReport";
import AgeWiseSummary from "./forms/reports/AgeWiseSummary";
import ReportAll from "./forms/reports/ReportAll";
import PdfUtility from "./forms/utility/PdfUtility";
import ConcreteEstimator, { ConcreteEstimatorEdit } from "./forms/utility/ConcreteEstimator";
import ConcreteEstimatorTable from "./forms/utility/ConcreteEstimatorTable";
import SalesRepForm from './forms/admin/SalesRepForm';
import SalesRepresentativeTable from './forms/admin/SalesRepresentativeTable';
import GroupForm from "./forms/admin/GroupForm";
import GroupFormEdit from "./forms/admin/GroupFormEdit";
import GroupFormTable from "./forms/admin/GroupFormTable";
import Plant from "./forms/admin/Plant";
import PlantEdit from "./forms/admin/PlantEdit";
import PlantTable from "./forms/admin/PlantTable";
import PlantConfigurationTable from "./forms/admin/PlantConfigurationTable";
import PlantConfiguration from "./forms/admin/PlantConfiguration";
import PlantConfigurationEdit from "./forms/admin/PlantConfigurationEdit";
import ProductTable from "./forms/admin/ProductTable";
import PermissionTable from "./forms/admin/PermissionTable";
import CustomerMainTable from "./forms/marketing/CustomerMainTable";
import SalesOrderTable from "./forms/marketing/SalesOrderTable";
import DesignMixTable from "./forms/qualitycontrol/DesignMixTable";
import WorkScheduleTable from "./forms/Planning/WorkScheduleTable";
import PumpClearanceTable from "./forms/dispatch/PumpClearanceTable";
import PurchaseInvoiceTable from "./forms/purchase/PurchaseInvoiceTable";
import CheckInTable from "./forms/gate/CheckInTable";
import EquipmentTable from "./forms/Transport/EquipmentTable";
import BankTable from "./forms/accounts/BankTable";
import CreditNoteTable from "./forms/accounts/CreditNoteTable";
import DebitNoteTable from "./forms/accounts/DebitNoteTable";
import DispatchReport from "./forms/reports/DispatchReport";
import DispatchReportSummary from "./forms/reports/DispatchReportSummary";
import SalesPostingReport from "./forms/reports/SalesPostingReport";
import LedgerAccount from "./forms/reports/LedgerAccount";
import AccountsReceivableAgewise from "./forms/reports/AccountsReceivableAgewise";
import TaxTable from "./forms/admin/TaxTable";
import GangTable from "./forms/admin/GangTable";
import IPAddressTable from "./forms/admin/IPAddressTable";
import NumberSettingTable from "./forms/admin/NumberSettingTable";
import Bank from "./forms/accounts/Bank";
import BankEdit from "./forms/accounts/BankEdit";
import SalesInvoice from "./forms/accounts/SalesInvoice";
import GoodsReceiptNote from "./forms/store/GoodsReceiptNote";
import GoodsReceiptNoteEdit from "./forms/store/GoodsReceiptNoteEdit";
import GoodsReceiptNoteTable from "./forms/store/GoodsReceiptNoteTable";
import AgeWiseReport from "./forms/reports/AgeWiseReport";
import NotFound from "./NotFound";  
import { useCookies } from 'react-cookie';
import Settings from './forms/admin/Settings';
import SessionTimeoutMonitor from './components/SessionTimeoutMonitor';
import { isAuthenticated } from './authSession';

function App() {
  const [cookies] = useCookies(['myToken']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);

  const hasCategory = (permission) => {
    const value = category?.myCategory;
    return Array.isArray(value) && value.includes(permission);
  };
  const isSuperuser = Boolean(superuser?.mySuperuser);

  const AdminWrapper = () => {
      return (isSuperuser || hasCategory('is_rmc_admin')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const SuperuserOnlyWrapper = () => {
      return isSuperuser ? <Outlet /> : <Navigate to="/Home" />
    };
    const MarkettingWrapper = () => {
      return (isSuperuser || hasCategory('is_marketting')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const QtyCtrlWrapper = () => {
      return (isSuperuser || hasCategory('is_qty_ctrl')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const PlanningWrapper = () => {
      return (isSuperuser || hasCategory('is_planning')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const DispatchWrapper = () => {
      return (isSuperuser || hasCategory('is_dispatch')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const EquipmentWrapper = () => {
      return (isSuperuser || hasCategory('is_transport')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const GateWrapper = () => {
      return (isSuperuser || hasCategory('is_gate')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const AccountsWrapper= () => {
      return (isSuperuser || hasCategory('is_accounts')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const PurchaseWrapper = () => {
      return (isSuperuser || hasCategory('is_purchase')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const StoreWrapper= () => {
      return (isSuperuser || hasCategory('is_store')) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const UtilityWrapper = () => {
      return (
        isSuperuser
        || hasCategory('is_utility')
        || hasCategory('is_rmc_admin')
        || hasCategory('add_concrete_estimator_master')
        || hasCategory('view_concrete_estimator_master')
        || hasCategory('change_concrete_estimator_master')
        || hasCategory('delete_concrete_estimator_master')
      ) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const ReportWrapper= () => {
      return (
        isSuperuser
        || hasCategory('view_accounts_reports')
        || hasCategory('view_transport_reports')
        || hasCategory('view_marketting_reports')
        || hasCategory('view_dispatch_reports')
        || hasCategory('view_store_reports')
      ) ? <Outlet /> : <Navigate to="/Home" />;
    };
    const AuthWrapper = () => {
      return isAuthenticated(cookies) ? <Outlet /> : <Navigate to="/" replace />;
    };
  return (
    <BrowserRouter>
    <div className="App" id="outer-container">
					   
              <Routes>
                  <Route exact path="/" element={<Login />} />
                  <Route element={<AuthWrapper />}>
                    <Route exact path="/Home" element={<Home />} />
                  
                  <Route element={<SuperuserOnlyWrapper />}>
                      <Route path="/Permission" element={<Permission />} />
                      <Route path="/PermissionTable" element={<PermissionTable />} />
                      <Route path="/PermissionEdit/:id"  element={<PermissionEdit />} />
                      <Route path="/IpAddress" element={<IpAddress />} />
                      <Route path="/IPAddressTable" element={<IPAddressTable />} />
                      <Route path="/IpAddressEdit/:id"  element={<IpAddressEdit />} />
                      <Route path="/User" element={<User />} />
                      <Route path="/UserTable" element={<UserTable />} />
                      <Route path="/UserEdit/:id"  element={<UserEdit />} /> 
                  </Route>
                  
                  <Route element={<AdminWrapper />}>
                      <Route path="/Company" element={<CompanyForm/>} /> 
                      <Route path="/CompanyTable" element={<CompanyTable />} />
                      <Route path="/CompanyEdit/:id" element={<CompanyForm />} />
                      <Route path="/Plant" element={<Plant />} />
                      <Route path="/PlantTable" element={<PlantTable />} />
                      <Route path="/PlantEdit/:id"  element={<PlantEdit />} />
                      <Route path="/Unit" element={<UnitForm />} />
                      <Route path="/UnitTable" element={<UnitTable />} />
                      <Route path="/UnitEdit/:id"  element={<UnitForm />} />
                      <Route path="/SalesRep" element={<SalesRepForm />} />
                      <Route path="/SalesRepTable" element={<SalesRepresentativeTable />} />
                      <Route path="/SalesRepEdit/:id"  element={<SalesRepForm />} />
                      <Route path="/Tax" element={<Tax />} />
                      <Route path="/TaxTable" element={<TaxTable />} />
                      <Route path="/TaxEdit/:id"  element={<TaxEdit />} />
                      <Route path="/Gang" element={<Gang />} />
                      <Route path="/GangTable" element={<GangTable />} />
                      <Route path="/GangEdit/:id"  element={<GangEdit />} />
                      <Route path="/Product" element={<Product />} />
                      <Route path="/ProductTable" element={<ProductTable />} />
                      <Route path="/ProductEdit/:id"  element={<ProductEdit />} />
                      <Route path="/NumberSetting" element={<NumberSetting />}/>
                      <Route path="/NumberSettingTable" element={<NumberSettingTable />}/>
                      <Route path="/NumberSettingEdit/:id"  element={<NumberSettingEdit />} />
                      <Route path="/ApprovalSetting" element={<ApprovalSetting />}/>
                      <Route path="/ApprovalSettingTable" element={<ApprovalSettingTable />}/>
                      <Route path="/ApprovalSettingEdit/:id"  element={<ApprovalSettingEdit />} />
                      <Route path="/PlantConfiguration" element={<PlantConfiguration />} />
                      <Route path="/PlantConfigurationTable" element={<PlantConfigurationTable />} />
                      <Route path="/PlantConfigurationEdit/:id"  element={<PlantConfigurationEdit />} />
                  </Route>
                
                  <Route element={<MarkettingWrapper />}>
                      <Route path="/CustomerMain" element={<CustomerMain />} />
                      <Route path="/CustomerMainTable" element={<CustomerMainTable />} />
                      <Route path="/CustomerMainEdit/:id"  element={<CustomerMainEdit />} />
                      <Route path="/CustomerSite" element={<CustomerSite />} />
                      <Route path="/CustomerSiteTable" element={<CustomerSiteTable />} />
                      <Route path="/CustomerSiteEdit/:id"  element={<CustomerSiteEdit />} />
                      <Route path="/Quotation" element={<Quotation />} />
                      <Route path="/QuotationEdit/:id"  element={<QuotationEdit />} />
                      <Route path="/QuotationTable" element={<QuotationTable />} /> 
                      <Route path="/SalesOrder" element={<SalesOrder />} />
                      <Route path="/SalesOrderTable" element={<SalesOrderTable />} />
                      <Route path="/SalesOrderEdit/:id"  element={<SalesOrderEdit />} />
                      {/* <Route path="/SOApproval/:id"  element={<SOApproval />} /> */}
                  </Route>

                  <Route element={<QtyCtrlWrapper />}>
                      <Route path="/DesignMix" element={<DesignMix />} />
                      <Route path="/DesignMixTable" element={<DesignMixTable />} />
                      <Route path="/DesignMixEdit/:id" element={< DesignMixEdit/>} />
                      <Route path = "/MoistureCorrection" element={<MoistureCorrection />}/>
                      <Route path="/MoistureCorrectionTable" element={<MoistureCorrectionTable />} />
                      <Route path="/MoistureCorrectionEdit/:id" element={< MoistureCorrectionEdit/>} />
                      <Route path = "/CubeTestReport" element={<CubeTestReport />}/>
                      <Route path = "/CubeTestReportEdit/:id" element={<CubeTestReportEdit />}/>
                      <Route path="/CubeTestReportTable" element={<CubeTestReportTable />} />
                  </Route>

                  <Route element={<PlanningWrapper />}>
                      <Route path="/WorkSchedule" element={<WorkSchedule />} />
                      <Route path="/WorkScheduleTable" element={<WorkScheduleTable />} />
                      <Route path="/WorkScheduleEdit/:id" element={<WorkScheduleEdit />} />
                      <Route path="/JobCompletion/:id" element={<JobCompletion />} />
                      <Route path="/JobCompletionReport/:id" element={<JobCompletionReport />} />
                  </Route>

                  <Route element={<DispatchWrapper />}>
                      <Route path="/PumpClearance" element={<PumpClearance />} />
                      <Route path="/PumpClearanceTable" element={<PumpClearanceTable />} />
                      <Route path="/PumpClearanceEdit/:id" element={<PumpClearanceEdit />} />
                      <Route path="/DeliveryChallan" element={<DeliveryChallan />} />
                      <Route path="/DeliveryChallanEdit/:id" element={<DeliveryChallanEdit />} />
                      <Route path="/DeliveryChallanTable" element={<DeliveryChallanTable />} />
                      <Route path="/QcDeliveryChallanList" element={<DeliveryChallanTable viewOnly />} />
                  </Route>

                  <Route element={<EquipmentWrapper />}>
                      <Route path="/Equipment" element={<Equipment />} />
                      <Route path="/EquipmentTable" element={<EquipmentTable />} />
                      <Route path="/EquipmentEdit/:id" element={<EquipmentEdit />} />
                  </Route>

                  <Route element={<PurchaseWrapper />}>
                    <Route path="/Vendor" element={<Vendor />} />
                    <Route path="/VendorTable" element={<VendorTable />} />
                    <Route path="/VendorEdit/:id"  element={<VendorEdit />} />
                    <Route path="/PurchaseOrder" element={<PurchaseOrder />} />
                    <Route path="/PurchaseOrderEdit/:id" element={<PurchaseOrderEdit/>} />
                    <Route path="/PurchaseOrderTable" element={<PurchaseOrderTable/>} />
                    <Route path="/PurchaseInvoice" element={<PurchaseInvoice />} />
                    <Route path="/PurchaseInvoiceEdit/:id"  element={<PurchaseInvoiceEdit />} />
                    <Route path="/PurchaseInvoiceTable" element={<PurchaseInvoiceTable />} />
                    <Route path="/PurchaseCreditNote" element={<PurchaseCreditNote />} />
                    <Route path="/PurchaseCreditNoteEdit/:id" element={<PurchaseCreditNoteEdit />} />
                    <Route path="/PurchaseCreditNoteTable" element={<PurchaseCreditNoteTable />} />
                    <Route path="/PurchaseDebitNote" element={<PurchaseDebitNote />} />
                    <Route path="/PurchaseDebitNoteEdit/:id" element={<PurchaseDebitNoteEdit />} />
                    <Route path="/PurchaseDebitNoteTable" element={<PurchaseDebitNoteTable />} />
                  </Route>
                  
                  <Route element={<GateWrapper />}>
                      <Route path="/CheckIn" element={<CheckIn/>} />
                      <Route path="/CheckInTable" element={<CheckInTable/>} />
                      <Route path="/CheckInEdit/:id" element={<CheckInEdit/>} />
                      <Route path="/CheckOut" element={<CheckOut/>} />
                      <Route path="/CheckOutTable" element={<CheckOutTable/>} />
                      <Route path="/CheckOutEdit/:id" element={<CheckOutEdit/>} />
                      <Route path="/VehicleGatePass" element={<VehicleGatePass/>} />
                      <Route path="/VehicleGatePassEdit/:id" element={<VehicleGatePassEdit/>} />
                      <Route path="/VehicleGatePassTable" element={<VehicleGatePassTable/>} />
                  </Route>
                  
                  <Route element={<AccountsWrapper />}>
                      <Route path="/GroupForm" element={<GroupForm />} />
                      <Route path="/GroupFormEdit/:id" element={<GroupFormEdit />} /> 
                      <Route path="/GroupFormTable" element={<GroupFormTable />} />
                      <Route path="/SalesInvoice" element={<SalesInvoice/>} />
                      <Route path="/SalesInvoiceEdit/:id" element={<SalesInvoiceEdit/>} />
                      <Route path="/SalesInvoiceTable" element={<SalesInvoiceTable/>} /> 
                      <Route path="/Bank" element={<Bank/>} />
                      <Route path="/BankEdit/:id" element={<BankEdit/>} />
                      <Route path="/BankTable" element={<BankTable/>} />
                      <Route path="/ReceiptVoucher" element={<ReceiptVoucher/>} />
                      <Route path="/ReceiptVoucher/edit/:id" element={<ReceiptVoucher/>} />
                      <Route path="/ReceiptVoucherEdit/:id" element={<ReceiptVoucherEdit/>} />
                      <Route path="/ReceiptVoucherTable" element={<ReceiptVoucherTable/>} />
                      <Route path="/PaymentVoucher" element={<PaymentVoucher/>} />
                      <Route path="/PaymentVoucherEdit/:id" element={<PaymentVoucherEdit/>} />
                      <Route path="/PaymentVoucherTable" element={<PaymentVoucherTable/>} />
                      <Route path="/ContraVoucher" element={<ContraVoucher/>} />
                      <Route path="/ContraVoucherEdit/:id" element={<ContraVoucherEdit/>} />
                      <Route path="/ContraVoucherTable" element={<ContraVoucherTable/>} />
                      <Route path="/GeneralJournal" element={<GeneralJournal/>} />
                      <Route path="/GeneralJournal/edit/:id" element={<GeneralJournal/>} />
                      <Route path="/GeneralJournalEdit/:id" element={<GeneralJournalEdit/>} />
                      <Route path="/GeneralJournalTable" element={<GeneralJournalTable/>} />
                      <Route path="/CreditNote" element={<CreditNote/>} />
                      <Route path="/CreditNoteEdit/:id" element={<CreditNoteEdit/>} />
                      <Route path="/CreditNoteTable" element={<CreditNoteTable/>} />
                      <Route path="/DebitNote" element={<DebitNote/>} />
                      <Route path="/DebitNoteEdit/:id" element={<DebitNoteEdit/>} />
                      <Route path="/DebitNoteTable" element={<DebitNoteTable/>} />
                      <Route path="/DirectInvoice" element={<DirectInvoice/>} />
                      <Route path="/DirectInvoiceEdit/:id" element={<DirectInvoiceEdit/>} /> 
                  </Route>
                  
                  <Route element={<StoreWrapper />}>
                      <Route path="/GoodsReceiptNote" element={<GoodsReceiptNote />} />
                      <Route path="/GoodsReceiptNoteTable" element={<GoodsReceiptNoteTable />} />
                      <Route path="/GoodsReceiptNoteEdit/:id" element={<GoodsReceiptNoteEdit/>} />
                      <Route path="/ConsumptionNote" element={<ConsumptionNote />} />
                      <Route path="/ConsumptionNoteTable" element={<ConsumptionNoteTable />} />
                      <Route path="/ConsumptionNoteEdit/:id" element={<ConsumptionNoteEdit />} />
                      <Route path="/DieselConsumption" element={<DieselConsumption />} />
                      <Route path="/DieselConsumptionTable" element={<DieselConsumptionTable />} />
                      <Route path="/DieselConsumptionEdit/:id" element={<DieselConsumptionEdit />} />
                      <Route path="/DieselConsumptionView/:id" element={<DieselConsumptionView />} />
                  </Route>

                  <Route element={<UtilityWrapper />}>
                      <Route path="/ConcreteEstimator" element={<ConcreteEstimator />} />
                      <Route path="/ConcreteEstimatorTable" element={<ConcreteEstimatorTable />} />
                      <Route path="/ConcreteEstimatorEdit/:id" element={<ConcreteEstimatorEdit />} />
                      <Route path="/PdfUtility" element={<PdfUtility />} />
                  </Route>

                  <Route element={<ReportWrapper />}>
                    <Route path="/ReportAll" element={<ReportAll />} />
                  </Route>

                    <Route path="/CustomerDataReport"  element={<CustomerDataReport />} />
                    <Route path="/CubeTestReport"  element={<CubeTestReport />} />
                    <Route path="/ProductionReport"  element={<ProductionReport />} />
                    <Route path="/EquipmentReport"  element={<EquipmentReport />} />
                    <Route path="/GstReport"  element={<GstReport />} />
                    <Route path="/ReceiptReport"  element={<ReceiptReport />} />
                    <Route path="AccountReceivableReport"  element={<AccountReceivableReport />} />
                    <Route path="/AgeWiseSummary"  element={<AgeWiseSummary />} />
                    <Route path="/DispatchReport" element={<DispatchReport />} />
                    <Route path="/DispatchReportSummary" element={<DispatchReportSummary />} />
                    <Route path="/GoodsReceiptNote" element={<GoodsReceiptNote />} />
                    <Route path="/SalesPostingReport" element={<SalesPostingReport />} />
                    <Route path="/AgeWiseReport" element={<AgeWiseReport />} />
                    <Route path="/LedgerAccount" element={<LedgerAccount />} />
                    <Route path="/AccountsReceivableAgewise" element={<AccountsReceivableAgewise />} />
                  {/* only match this when no other routes match */}
                  <Route path ="*" element={<NotFound />} />
                  </Route>
                  </Routes>
                  <SessionTimeoutMonitor />
                  <Settings/>
    </div>
    </BrowserRouter>
  );
}

export default App;
                

